import { AsyncStateNotification } from '@ui/notifications';
import { createAsyncSelectors } from '@lib/selectors';
import { Divider } from 'antd';
import { importsActions } from '@sonar-software/sonar-imports';
import { ImportStatistics } from './ImportStatistics';
import { LastSyncStatus } from './LastSyncStatus';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { useAsyncStateWithPreload } from '@hooks';

import { Else, If, Then } from 'react-if';

const selectors = createAsyncSelectors((state) => state.imports.salesforce.summary.get);

export const LastSyncSummary: React.FC = () => {
	const { data, isRequested } = useAsyncStateWithPreload(
		selectors,
		importsActions.requestGetImportsSalesforceSummary,
		true
	);

	return (
		<>
			<If condition={ isRequested }>
				<Then>
					<LoadingSpinner spinning />
				</Then>
				<Else>
					<div id='last-sync-summary'>
						<ImportStatistics summary={ data } />
						<Divider />
						<LastSyncStatus />
					</div>
				</Else>
			</If>
			<AsyncStateNotification
				errored={ NOTIFICATIONS_COPY.ERROR_IMPORT_SUMMARY }
				failed={ NOTIFICATIONS_COPY.FAILED_IMPORT_SUMMARY }
				stateSelector={ selectors.state } />
		</>
	);
};
